import React from 'react';
import Chip from '../Common/Chip';
import SkillIcon from 'material-ui/svg-icons/social/public';

const SkillChip = ({skill, onDelete = null, userId = null, disabled = false}) => (
    <Chip
        avatar={<SkillIcon />}
        label={skill.name}
        onDelete={onDelete}
        disabled={disabled}
        url={`/dashboard/skill/${skill.id}${!!userId ? `/user/${userId}` : ''}`}
        theme="primary"
    />
);

export default SkillChip;
